// extracted by mini-css-extract-plugin
module.exports = {"yellow":"styles_yellow__3oC9s","green":"styles_green__3IO5r","gray":"styles_gray__yH8y6","blue":"styles_blue__1xE0u","purple":"styles_purple__1KyaO"};